<template>
	<div>
		<div class="main-accounting">
			<h3 class="py-3 px-4 font-weight-bold accounting-headline">
				Definicion de Asientos
			</h3>
			<template >
				<v-layout wrap align-center mx-4 py-3 class="accounting-container"
				>
					<v-flex flex content-semi-green xs12 pl-9 py-3 mb-4>
						<label class="caption"  >Integridad contable</label>
					</v-flex>
					<v-flex xs5 pl-3>
						<label class="caption">Permite cancelar el asiento al contabilizar automaticamente</label>
					</v-flex>
					<v-flex flex  xs3 pl-9 py-3 mb-4 >
								<v-switch
									v-model="automaticAccounting"
									:label="automaticAccountingName(automaticAccounting)"
									color="success"
									class="justify-center align-center my-0 pt-0 accounting-switch"
									hide-details
									@change="getData({ model:  'automaticAccounting', value: $event})"
								></v-switch>
					</v-flex>
					<v-flex xs5 pl-3>
						<label class="caption">Grabar solo asientos cuadrados</label>
					</v-flex>
					<v-flex flex  xs3 pl-9 py-3 mb-4 >
								<v-switch
									v-model="squareSeats"
									:label="automaticSquareSeats(squareSeats)"
									color="success"
									class="justify-center align-center my-0 pt-0 accounting-switch"
									@change="getData({ model:  'squareSeats', value: $event})"
									hide-details
								></v-switch>
					</v-flex>
					<v-flex xs5 pl-3>
						<label class="caption">Grabar asientos contables con Centro de Costos</label>
					</v-flex>
					<v-flex flex  xs3 pl-9 py-3 mb-4 >
								<v-switch
									v-model="autoCenterCost"
									:label="automaticCenterCost(autoCenterCost)"
									color="success"
									class="justify-center align-center my-0 pt-0 accounting-switch"
									@change="getData({ model:  'autoCenterCost', value: $event})"
									hide-details
								></v-switch>
					</v-flex>
					<v-flex xs5 pl-3>
						<label class="caption">Imprimir asiento al momento de guardar el asiento</label>
					</v-flex>
					<v-flex flex  xs3 pl-9 py-3 mb-4 >
								<v-switch
									v-model="printSeat"
									:label="automaticPrintSeat(printSeat)"
									color="success"
									class="justify-center align-center my-0 pt-0 accounting-switch"
									@change="getData({ model:  'printSeat', value: $event})"
									hide-details
								></v-switch>
					</v-flex>
					<v-flex xs5 pl-3>
						<label class="caption">No permitir que contabilice rol facturador </label>
					</v-flex>
					<v-flex flex  xs3 pl-9 py-3 mb-4 >
								<v-switch
									v-model="accountingEntries"
									:label="automaticAccountingEntries(accountingEntries)"
									color="success"
									class="justify-center align-center my-0 pt-0 accounting-switch"
									@change="getData({ model:  'accountingEntries', value: $event})"
									hide-details
								></v-switch>
					</v-flex>
				</v-layout>
			</template>
			<v-layout wrap align-center justify-center class="save-container">
				<v-flex text-xs-center v-if="disabledbtnSave">
					<v-btn
						small
						class="btn-action"
						color="cyan"
						@click="$emit('save-Data')"
					>
						Guardar
					</v-btn>
				</v-flex>
				<v-flex text-xs-center v-else>
					<v-btn
						small
						class="btn-action"
						color="cyan"
						@click="$emit('edit-Data')"
					>
						Editar
					</v-btn>
				</v-flex>
			</v-layout>
		</div>
	</div>
</template>

<script>
	import { minValue, required } from 'vuelidate/lib/validators';
	import appTooltipButton from '@/components/shared/app-tooltip-button';

	async function mounted() {
		this.loadResources();
		this.automaticAccountingName();
		this.automaticSquareSeats();
		this.automaticCenterCost();
		this.automaticPrintSeat();
		this.automaticAccountingEntries();
	}

	function created() {
		this.loadSettings();
	}

	async function loadSettings() {
		const { customerId, subsidiaryId } = this.$route.query;
		try {
			const { data: response } = await this.$http.get(`settings/${customerId}/${subsidiaryId}`);
			if (Object.entries(response).length === 0) {
				this.disabledbtnSave = true;
			} else {
				this.disabledbtnSave = false;
			}

			/* await this.$http.patch(`automatic-configuration-multiple/${subsidiaryId}`, body); */
			this.showNotification('La configuración de cuentas contables cargada.');
			this.params.subsidiaryId = null;
			const { additionalSettings } = response;
			this.automaticAccounting = additionalSettings && additionalSettings.automaticAccounting ?
				additionalSettings.automaticAccounting : false;
			this.squareSeats = additionalSettings && additionalSettings.squareSeats ?
				additionalSettings.squareSeats : false;
			this.autoCenterCost = additionalSettings && additionalSettings.autoCenterCost ?
				additionalSettings.autoCenterCost : false;
			this.printSeat = additionalSettings && additionalSettings.printSeat ?
				additionalSettings.printSeat : false;
			this.accountingEntries = additionalSettings && additionalSettings.accountingEntries ?
				additionalSettings.accountingEntries : false;
			this.additionalSettings = {
				automaticAccounting: additionalSettings.automaticAccounting || false,
				squareSeats: additionalSettings.squareSeats || false,
				autoCenterCost: additionalSettings.autoCenterCost || false,
				printSeat: additionalSettings.printSeat || false,
				accountingEntries: additionalSettings.accountingEntries || false,
			};
		} catch (err) {
			if (err.status === 500) {
				this.showGenericError();
			}
		} finally {
			this.loading = false;
		}
	}

	function automaticSquareSeats(squareSeats) {
		return squareSeats ? 'Sí' : 'No';
	}

	function automaticCenterCost(autoCenterCost) {
		return autoCenterCost ? 'Sí' : 'No';
	}

	function automaticPrintSeat(printSeat) {
		return printSeat ? 'Sí' : 'No';
	}

	function automaticAccountingEntries(accountingEntries) {
		return accountingEntries ? 'Sí' : 'No';
	}

	function getData({ model, value }) {
		this.additionalSettings[model] = value;
		this.$emit('get-Data', this.additionalSettings);
	}

	async function loadResources() {
		const subsidiaryId = this.$route.query.subsidiaryId || this.currentSubsidiary.id;
		const request = [
			this.$http.get('type-register', { params: { subsidiaryId } }),
		];
		[{ data: this.modules }] = await Promise.all(request);
		this.rows = this.modules;
	}

	function automaticAccountingName(allowVisualize) {
		return allowVisualize ? 'Sí' : 'No';
	}

	function validations() {
		return {
			model: {
				moduleId: { minValue: minValue(1), required },
			},
		};
	}

	function data() {
		return {
			modules: [],
			model: {
				moduleId: null,
			},
			columns: [
				{ id: 1, name: 'Código', value: 'code', checked: true, visible: true },
				{ id: 2, name: 'Definición', value: 'name', checked: true, visible: true },
				{ id: 3, name: 'Módulo', value: 'name', checked: true, visible: true },
				{ id: 6, name: 'Acciones', checked: true, visible: true, flagVisible: true },
			],
			currentPage: 1,
			lastPage: 1,
			rows: [],
			automaticAccounting: false,
			squareSeats: false,
			autoCenterCost: false,
			accountingEntries: false,
			printSeat: false,
			disabledbtnSave: false,
			additionalSettings: {
				automaticAccounting: false,
				squareSeats: false,
				autoCenterCost: false,
				accountingEntries: false,
				printSeat: false,
			},
		};
	}

	export default {
		name: 'accounting-parametrization-misc-two',
		mounted,
		components: {
			BaseSelect: () => import('@/components/shared/inputs/base-select'),
			BaseInput: () => import('@/components/shared/inputs/base-input'),
			appTooltipButton,
		},
		data,
		created,
		methods: {
			automaticAccountingName,
			loadResources,
			automaticSquareSeats,
			getData,
			loadSettings,
			automaticCenterCost,
			automaticPrintSeat,
			automaticAccountingEntries,
		},
		props: {
			disabled: {
				default: false,
				type: Boolean,
			},
		},
		validations,
	};
</script>

<style lang="scss" scoped>
	.main-accounting {
		background-color: white;
		border-radius: 20px;
		font-family: font(AvenirRegular);
		font-size: size(medium);
	}
	.accounting-container {
		border-bottom: 1px solid color(grey-background-filter);
	}

	.accounting-name {
		font-family: font(AvenirDemi);
	}

	.save-container {
		background-color: white;
		bottom: 0;
		height: 68px;
		left: 0;
		position: fixed;
		width: 100%;
	}
	.caption {
		font-size: 15px !important;
		font-weight: 900 !important;
	}
	.accounting-headline {
		background-color: PowderBlue !important;
		border-top-left-radius: 20px;
		border-top-right-radius: 20px;
	}
	.content-semi-green {
		background-color: #e0f3f3;
		color: #4a4a4a;
		font-family: Opens_regular;
		@include flex-center;
		.caption {
			font-size: 15px !important;
			font-weight: 900 !important;
		}
	}
	.collapse-menu {
	display: none;

	@media (max-width: 780px) {
		align-items: center;
		display: block;
		height: 100%;
		justify-content: center;
	}

		.v-menu {
		align-items: center;
		display: flex;
		height: 100%;
		justify-content: center;

		.v-btn {
			background-color: color(btn-green);
			height: 25px;
			margin: 0;
			width: 25px;
		}
	}
}

	.menu-content {
		align-items: center;
		color: color(red-icon);
		display: grid;
		font-family: font(AvenirRegular);
		font-size: size(small) !important;
		grid-column-gap: 3px;
		grid-template-columns: 15px 1fr;
		width: 175px;

		.factory {
			color: color(secondary);
		}

		.edit {
			color: color(btn-green);
		}
	}

	.btn-menu-content {
		border-bottom: 1px solid color(grey-background-table);
	}
</style>



// WEBPACK FOOTER //
// src/components/accounting-parametrizations/accounting-parametrization-misc-two.vue